(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BU_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', (e) => {
    const utility_bar = document.querySelector('.utility-bar');
    if (utility_bar) {
      function setHeaderInfoOffset() {
        // const bh = utility_bar.getBoundingClientRect().height;
        const bh = utility_bar.offsetHeight;
        document.documentElement.style.setProperty('--header-info-offset', `${bh}px`);
      }
      setHeaderInfoOffset();
      window.addEventListener('resize', setHeaderInfoOffset());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (e) => {
    const slider = document.querySelector('.featured-collection .swiper');
    if (slider) {
      const swiper = new Swiper(slider, {
        freeMode: true,
        slidesPerView: 'auto',
        mousewheel: true,
        observer: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initSearchMenu() {
    const container = document.querySelector('.search-menu');
    const header_control = container.querySelector('.search-menu__control');
    const header_control_inner = header_control.querySelector('.swiper-wrapper');
    const sections = container.querySelectorAll('.search-menu__section');
    const categories = [...sections].map((elem) => {
      return elem.dataset.categoryTitle;
    });
    const toggle_button = document.querySelector('.menu-button--search');
    const OPEN_CLASS = 'is-search-menu-open';

    let last_index = null;

    // console.log(categories);
    categories.forEach((cat_title) => {
      const _button = document.createElement('BUTTON');
      const _span = document.createElement('SPAN');
      _button.classList.add('swiper-slide');
      _span.textContent = cat_title;
      _button.append(_span);
      header_control_inner.append(_button);
    });

    function updateHistory() {
      requestAnimationFrame(() => {
        if (search_menu_main != null) {
          const _url = new URL(location.href);
          if (isMenuOpen()) {
            if (last_index != search_menu_main.realIndex) {
              last_index = search_menu_main.realIndex;
              const category_str = categories[last_index];
              _url.hash = `#navigation_${category_str}`;
              history.replaceState(null, null, _url.toString());
            }
          } else {
            if (last_index != null) {
              last_index = null;
              _url.hash = '';
              history.replaceState(null, null, _url.toString());
            }
          }
        }
      });
    }

    const header_control_swiper = new Swiper(header_control, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const search_menu_main = new Swiper('.search-menu__inner', {
      direction: 'vertical',
      slidesPerView: 'auto',
      freeMode: true,
      mousewheel: true,
      thumbs: {
        swiper: header_control_swiper,
      },
      on: {
        progress: updateHistory,
      },
    });

    const search_keyword_list = new Swiper('.search-menu__keywords', {
      slidesPerView: 'auto',
      freeMode: true,
      mousewheel: true,
      spaceBetween: '8',
    });

    [...document.querySelectorAll('.search-menu__articles')].forEach((article_slider) => {
      article_slider._slider = new Swiper(article_slider, {
        slidesPerView: 'auto',
        freeMode: true,
      });
    });

    function isMenuOpen() {
      return document.querySelector('body').classList.contains(OPEN_CLASS);
    }

    function openMenu(primary_index = null) {
      document.querySelector('body').classList.add(OPEN_CLASS);
      // トップページスライダーのタイマー停止用
      document.dispatchEvent(new CustomEvent('navigation:open'));

      if (primary_index != null) {
        // hash に直前セクションの記録があった場合
        header_control_swiper.slideTo(primary_index, 0);
        search_menu_main.slideTo(primary_index, 0);
        if (document.querySelector('.header-slider-control')) {
          document.querySelector('.header-slider-control').style.display = 'none'; // ヘッダーの元のコントロールを非表示に
        }
      } else {
        if (document.querySelector('.header-slider-control')) {
          // トップページでメインスライダーが動いている場合その状態をメニューに反映
          const index_main_slider = document.querySelector('.index-main-slider.swiper-initialized');
          if (index_main_slider && index_main_slider.swiper.slides[index_main_slider.swiper.realIndex] != null) {
            const sub_slider =
              index_main_slider.swiper.slides[index_main_slider.swiper.realIndex].querySelector('.index-sub-slider');
            if (sub_slider) {
              const current_category_title = sub_slider.dataset.categoryTitle;
              const on_search_menu_category_index = categories.indexOf(current_category_title);
              if (on_search_menu_category_index >= 0) {
                search_menu_main.slideTo(on_search_menu_category_index, 0);
              }
            }
          }
          const header_slider = document.querySelector('.header-slider-control');
          if (header_slider) {
            const header_slider_swiper = header_slider.swiper;
            if (header_slider_swiper != null) {
              const _translate = header_slider_swiper.getTranslate();
              setTimeout(() => {
                requestAnimationFrame(() => {
                  header_control_swiper.translateTo(_translate, 0);
                });
              }, 0);
            }
            header_slider.style.display = 'none'; // ヘッダーの元のコントロールを非表示に
          }
        }
      }
    }

    function closeMenu() {
      document.querySelector('body').classList.remove(OPEN_CLASS);
      document.dispatchEvent(new CustomEvent('navigation:close'));
      updateHistory();
      if (document.querySelector('.header-slider-control')) {
        document.querySelector('.header-slider-control').style.display = 'block';
      }
    }

    function toggleMenu() {
      if (document.querySelector('body').classList.contains(OPEN_CLASS)) {
        closeMenu();
      } else {
        openMenu();
      }
    }
    toggle_button.addEventListener('click', toggleMenu);

    // 初期値に#navigation_ががある場合
    if (location.hash != '') {
      const hash_on_open = location.hash;
      if (/^#navigation_/.test(hash_on_open)) {
        const hash_array = hash_on_open.split('_');
        const hash_dest = hash_array[1];
        const primary_index = categories.indexOf(hash_dest);
        if (primary_index >= 0) {
          console.log(hash_dest, primary_index);
          openMenu(primary_index);
        }
      }
    }
  }
  document.addEventListener('DOMContentLoaded', initSearchMenu, {
    once: true,
  });

  // ヘッダーの戻るリンクの遷移先設定
  function forceHistoryBack(e) {
    e.preventDefault();
    // console.log('forceHistoryBack');

    history.back();
    return;
  }

  function initHeaderBackLink(e = null) {
    console.log(e);

    const referrer = document.referrer;
    console.log(document.referrer);

    const prev_url = new URL(referrer);
    const current_url = new URL(location.href);

    prev_url.search = '';
    current_url.search = '';

    const regexp = new RegExp('^' + current_url.toString(), 'i');
    const header_back_links = document.querySelectorAll('.header__back, .header__close');
    // console.log('referrer:', prev_url.toString());
    // console.log('current:', current_url.toString());
    // console.log(regexp.test(prev_url.toString()));

    // 一旦リセット
    [...header_back_links].forEach((elem) => {
      elem.classList.remove('is-history-back');
      elem.removeEventListener('click', forceHistoryBack);
    });

    if (
      prev_url.host == current_url.host &&
      regexp.test(prev_url.toString()) == false &&
      /\/products\//gi.test(prev_url.toString()) == false
    ) {
      [...header_back_links].forEach((elem) => {
        elem.classList.add('is-history-back');
        elem.addEventListener('click', forceHistoryBack, {
          url: prev_url.toString(),
        });
      });
    }
  }
  document.addEventListener('DOMContentLoaded', initHeaderBackLink, {
    once: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  // ヒーローは position: fixed のため、縦方向のホイール・スワイプが
  // スクロール領域(.article-template)に伝わらない。縦方向の操作だけをスクロールに転送する。
  // （画像1枚のときは CSS の pointer-events: none で素通しするため不要）
  function forwardVerticalScroll(elem, scroller) {
    elem.addEventListener(
      'wheel',
      (evt) => {
        if (evt.ctrlKey || Math.abs(evt.deltaY) <= Math.abs(evt.deltaX)) return;
        const unit = evt.deltaMode === 1 ? 16 : evt.deltaMode === 2 ? scroller.clientHeight : 1;
        evt.preventDefault();
        scroller.scrollBy({ top: evt.deltaY * unit });
      },
      { passive: false }
    );

    let start_x = 0;
    let start_y = 0;
    let last_y = 0;
    let last_time = 0;
    let velocity = 0;
    let axis = null;
    let inertia_id = 0;

    elem.addEventListener(
      'touchstart',
      (evt) => {
        cancelAnimationFrame(inertia_id);
        const touch = evt.touches[0];
        start_x = touch.clientX;
        start_y = last_y = touch.clientY;
        last_time = evt.timeStamp;
        velocity = 0;
        axis = null;
      },
      { passive: true }
    );

    elem.addEventListener(
      'touchmove',
      (evt) => {
        if (evt.touches.length > 1) return;
        const touch = evt.touches[0];
        if (!axis) {
          const dx = Math.abs(touch.clientX - start_x);
          const dy = Math.abs(touch.clientY - start_y);
          if (Math.max(dx, dy) < 6) return;
          axis = dy > dx ? 'y' : 'x';
        }
        if (axis !== 'y') return;
        if (evt.cancelable) evt.preventDefault();
        const delta = last_y - touch.clientY;
        velocity = delta / Math.max(1, evt.timeStamp - last_time);
        scroller.scrollTop += delta;
        last_y = touch.clientY;
        last_time = evt.timeStamp;
      },
      { passive: false }
    );

    elem.addEventListener('touchend', () => {
      if (axis !== 'y') return;
      // 指を離した後の慣性スクロール
      let speed = velocity * 16;
      const step = () => {
        if (Math.abs(speed) < 0.5) return;
        scroller.scrollTop += speed;
        speed *= 0.95;
        inertia_id = requestAnimationFrame(step);
      };
      inertia_id = requestAnimationFrame(step);
    });
  }

  function initHeroSlider() {
    const hero_slider_elem = document.querySelector('.article-hero-slider');
    if (!hero_slider_elem) return;

    const getSlideCount = () => {
      const wrapper = hero_slider_elem.querySelector('.swiper-wrapper');
      return wrapper ? wrapper.children.length : 0;
    };

    const has_single_slide = getSlideCount() <= 1;
    const hero_slider = new Swiper(hero_slider_elem, {
      direction: 'horizontal',
      mousewheel: {
        enabled: !has_single_slide,
        forceToAxis: true,
        releaseOnEdges: true,
      },
      allowTouchMove: !has_single_slide,
      simulateTouch: !has_single_slide,
      parallax: true,
      speed: 600,
      slidesPerView: 1,
      watchOverflow: true,
    });

    if (has_single_slide) {
      hero_slider.disable();
      hero_slider.lockEdgeFunction = true;
      hero_slider.mousewheel.disable();
      hero_slider.params.mousewheel.enabled = false;
      hero_slider.params.allowTouchMove = false;
      hero_slider.params.simulateTouch = false;
    }

    initSliderThumbs(hero_slider, hero_slider_elem.querySelector('.article-hero-slider__thumbs'));

    const scroller = hero_slider_elem.closest('.article-template');
    if (!has_single_slide && scroller) forwardVerticalScroll(hero_slider_elem, scroller);
    preventHorizontalOverscroll(hero_slider_elem);

    function checkArticleContainerPosition() {
      const offset = 30;
      const articleContainer = document.querySelector('.article-body');
      if (articleContainer) {
        const rect = articleContainer.getBoundingClientRect();
        if (rect.top < 0) {
          hero_slider_elem.style.setProperty('--article-scroll-top', 0 + 'px');
          hero_slider.lockEdgeFunction = true;
          hero_slider.disable();
        } else {
          hero_slider_elem.style.setProperty('--article-scroll-top', rect.top + offset + 'px');
          if (!has_single_slide) {
            hero_slider.lockEdgeFunction = false;
            hero_slider.enable();
          }
        }
        requestAnimationFrame(checkArticleContainerPosition);
      }
    }
    checkArticleContainerPosition();
  }
  window.addEventListener('load', initHeroSlider);

  function initArticleRecommendSlider() {
    const slider = document.querySelector('.article-recommend__list.swiper');
    if (slider) {
      const swiper = new Swiper(slider, {
        freeMode: true,
        slidesPerView: 'auto',
        mousewheel: true,
        observer: true,
      });
    }
  }
  window.addEventListener('load', initArticleRecommendSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  function initBlogSlider() {
    const blog_slider = document.querySelector('.blog-slider');
    if (!blog_slider) return false;
    const pagination = blog_slider.querySelector('.blog-slider__pagination');
    function adjustPaginationPosition(swiper) {
      const pagination_rect = pagination.getBoundingClientRect();
      const scroll_height = pagination.scrollHeight;
      const position_adjust = swiper.activeIndex - swiper.previousIndex > 0 ? 3.5 : 0;
      const bullets = swiper.pagination.bullets;
      const active_bullet = bullets[Math.min(swiper.activeIndex, bullets.length - 1)];
      const active_bullet_rect = active_bullet.getBoundingClientRect();

      // console.log(
      //   position_adjust,
      //   pagination_rect.height,
      //   active_bullet_rect.top,
      //   pagination.scrollTop,
      //   scroll_height
      // );

      if (pagination_rect.height < scroll_height) {
        const pagination_st = pagination.scrollTop;
        const pagination_area_center = pagination_rect.height / 2 - pagination_rect.width * 3 * 0.5;
        const centered_scroll_position = Math.max(
          Math.min(
            pagination_st +
              active_bullet_rect.top -
              pagination_rect.top -
              pagination_area_center -
              position_adjust * pagination_rect.width,
            scroll_height
          ),
          0
        );
        // console.log(centered_scroll_position);
        pagination.classList.add('is-overflowed');
        pagination.scrollTo({ top: centered_scroll_position, behavior: 'smooth' });
      } else {
        pagination.classList.remove('is-overflowed');
        pagination.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    blog_slider.slider = new Swiper(blog_slider, {
      direction: 'vertical',
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      parallax: true,
      speed: 600,
      slidesPerView: 1,
      watchOverflow: true,
      pagination: {
        el: pagination,
        // clickable: true,
        // dynamicBullets: true,
        // dynamicMainBullets: 3,
      },
      on: {
        touchStart: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (evt.type == 'pointerdown') {
              swiper._touch_start_y = evt.clientY;
            } else {
              swiper._touch_start_y = evt.touches[0].clientY;
            }
          }
        },
        touchMove: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (evt.type == 'pointermove') {
              swiper._touch_move_y = evt.clientY;
            } else {
              swiper._touch_move_y = evt.touches[0].clientY;
            }
          }
        },
        touchEnd: (swiper, evt) => {
          if (swiper.slides.length == 1) {
            if (swiper._touch_start_y != null && swiper._touch_move_y != null) {
              const delta_y = swiper._touch_move_y - swiper._touch_start_y;
              swiper._touch_start_y = null;
              swiper._touch_move_y = null;
              if (delta_y < swiper.params.edgeSwipeThreshold * -1) {
                console.log('DOWN');
                // mainSliderEdgeSlideNext();
              } else if (delta_y > swiper.params.edgeSwipeThreshold * 1) {
                console.log('UP');
                // mainSliderEdgeSlidePrev();
              }
            }
          }
        },
        progress: (swiper, progress) => {
          if (progress < 0) {
            // mainSliderEdgeSlidePrev();
          } else if (progress > 1) {
            // mainSliderEdgeSlideNext();
          }
        },
        transitionStart: (swiper) => {
          adjustPaginationPosition(swiper);
        },
      },
    });

    function checkArticleContainerPosition() {
      const offset = 30;
      const articleContainer = document.querySelector('.article-body');
      if (articleContainer) {
        const rect = articleContainer.getBoundingClientRect();
        if (rect.top < 0) {
          hero_slider_elem.style.setProperty('--article-scroll-top', 0 + 'px');
          hero_slider.lockEdgeFunction = true;
          hero_slider.disable();
        } else {
          hero_slider_elem.style.setProperty('--article-scroll-top', rect.top + offset + 'px');
          hero_slider.lockEdgeFunction = false;
          hero_slider.enable();
        }
        requestAnimationFrame(checkArticleContainerPosition);
      }
    }
    checkArticleContainerPosition();
  }
  window.addEventListener('load', initBlogSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', (e) => {
      const product_main_slider_elem = document.querySelector('media-gallery .swiper');
      if (!product_main_slider_elem) return;

      const has_single_slide =
        product_main_slider_elem.querySelectorAll('.product-main-slider > .swiper-slide').length <= 1;
      const product_main_slider = new Swiper(product_main_slider_elem, {
        mousewheel: {
          enabled: !has_single_slide,
          forceToAxis: true,
          releaseOnEdges: true,
        },
        allowTouchMove: !has_single_slide,
        simulateTouch: !has_single_slide,
        parallax: true,
        speed: 600,
        slidesPerView: 1,
        watchOverflow: true,
      });

      if (has_single_slide) {
        product_main_slider.disable();
        product_main_slider.lockEdgeFunction = true;
      }

      preventHorizontalOverscroll(product_main_slider_elem);

      const thumbs_elem = product_main_slider_elem.querySelector('.product-main-slider__thumbs');
      const thumbs_slider = initSliderThumbs(product_main_slider, thumbs_elem);

      // バリエーション切替でメディアの並びが変わったらサムネイルも同じ順に並べ替える
      const main_wrapper = product_main_slider_elem.querySelector('.product-main-slider');
      if (thumbs_slider && main_wrapper) {
        new MutationObserver(() => {
          const media_ids = Array.from(main_wrapper.querySelectorAll(':scope > [data-media-id]')).map(
            (slide) => slide.dataset.mediaId
          );
          const thumbs_wrapper = thumbs_elem.querySelector('.swiper-wrapper');
          media_ids.forEach((media_id) => {
            const thumb = thumbs_wrapper.querySelector(`[data-thumb-media-id="${media_id}"]`);
            if (thumb) thumbs_wrapper.appendChild(thumb);
          });
          product_main_slider.update();
          thumbs_slider.update();
          product_main_slider.slideTo(0, 0);
          product_main_slider.emit('slideChange');
        }).observe(main_wrapper, { childList: true });
      }

      function checkArticleContainerPosition() {
        const offset = 30;
        const articleContainer = document.querySelector('.product__info-wrapper');
        if (articleContainer) {
          const rect = articleContainer.getBoundingClientRect();
          if (rect.top < 0) {
            product_main_slider_elem.style.setProperty('--article-scroll-top', 0 + 'px');
            product_main_slider.lockEdgeFunction = true;
            product_main_slider.disable();
          } else {
            product_main_slider_elem.style.setProperty('--article-scroll-top', rect.top + offset + 'px');
            if (!has_single_slide) {
              product_main_slider.lockEdgeFunction = false;
              product_main_slider.enable();
            }
          }
          requestAnimationFrame(checkArticleContainerPosition);
        }
      }
      checkArticleContainerPosition();
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-top-slider"] && !Shopify.designMode) return;
  try {
    
  function initIndexSliders() {
    const sub_sliders = document.querySelectorAll('.index-sub-slider');
    const header_control = document.querySelector('.header-slider-control');
    const header_control_inner = header_control.querySelector('.swiper-wrapper');
    const categories = [...sub_sliders].map((elem) => {
      return elem.dataset.categoryTitle;
    });
    categories.forEach((cat_title) => {
      const _button = document.createElement('BUTTON');
      const _span = document.createElement('SPAN');
      _button.classList.add('swiper-slide');
      _span.textContent = cat_title;
      _button.append(_span);
      header_control_inner.append(_button);
    });
    const header_control_swiper = new Swiper(header_control, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });
    const slider_main = new Swiper('.index-main-slider', {
      slidesPerView: 1,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      on: {
        slideChangeTransitionEnd: unlockEdgeFunction,
        init: (elem) => {
          // イントロ・ローディング表示中はフェードアウト開始まで待ってからスタート
          const intro = document.querySelector('#intro.is-active');
          const loading = document.querySelector('#pageLoading');
          const waitIntro = (callback) => {
            if (intro && !window.isIntroFinished) {
              document.addEventListener('intro:fadeout', callback, { once: true });
            } else if (loading && !window.isLoadingFinished) {
              document.addEventListener('loading:fadeout', callback, { once: true });
            } else {
              setTimeout(callback, 0);
            }
          };
          waitIntro(() => {
            const _swiper = slider_main.slides[slider_main.activeIndex].querySelector('.swiper');
            if (_swiper.swiper != null) {
              startSlideTimer(_swiper.swiper.slides[_swiper.swiper.activeIndex]);
            }
          });
        },
        transitionStart: (main_swiper) => {
          // スライダーのタイマーをリセット
          resetAllSubSlideTimers();
          const _swiper = main_swiper.slides[main_swiper.activeIndex].querySelector('.swiper');
          if (_swiper.swiper != null) {
            startSlideTimer(_swiper.swiper.slides[_swiper.swiper.activeIndex]);
          } else {
            console.log(_swiper);
          }
        },
        transitionEnd: (main_swiper) => {
          const _swiper = main_swiper.slides[main_swiper.previousIndex].querySelector('.swiper');
          if (_swiper.swiper != null) {
            const slides = _swiper.swiper.slides;
            const prev_slide = slides[_swiper.swiper.activeIndex];
            if (prev_slide.querySelector('video')) {
              const v = prev_slide.querySelector('video');
              v.pause();
              v.currentTime = 0;
            }
          }
        },
      },
      rewind: true,
      thumbs: {
        swiper: header_control_swiper,
      },
    });

    function resetAllSubSlideTimers() {
      sub_sliders.forEach((sub_slider) => {
        const timer_slides = sub_slider.querySelectorAll('.has-timer');
        timer_slides.forEach((slide) => {
          if (slide.remove_timer != null && typeof slide.remove_timer === 'function') {
            slide.remove_timer();
          }
        });
      });
    }

    function updateSliderProgressIndicator(elem, progress) {
      const _slide = elem.closest('.swiper-slide');
      _slide.style.setProperty('--slide-timer-progress', progress);
    }

    function sliderTimer(elem, duration = 4000) {
      // console.log('sliderTimer:', elem);
      let start_time = performance.now();
      let paused_at = null;
      let timer;
      let is_discarded = false;
      const update = (time) => {
        if (is_discarded || paused_at != null) {
          return;
        }
        const elapsed = time - start_time;
        const progress = Math.min(elapsed / duration, 1);
        updateSliderProgressIndicator(elem, progress);
        if (progress < 1) {
          timer = requestAnimationFrame(update);
        } else {
          // Reset the timer when it reaches the end
          subSliderSlideNext(elem);
          updateSliderProgressIndicator(elem, 0);
        }
        // console.log('update sliderTimer:', elem, progress);
      };
      elem.remove_timer = function () {
        is_discarded = true;
        cancelAnimationFrame(timer);
        updateSliderProgressIndicator(elem, 0);
        elem.remove_timer = null;
        elem.pause_timer = null;
        elem.resume_timer = null;
        elem.classList.remove('has-timer');
        // console.log('remove sliderTimer:', elem);
      };
      elem.pause_timer = function () {
        if (paused_at != null) {
          return;
        }
        paused_at = performance.now();
        cancelAnimationFrame(timer);
      };
      elem.resume_timer = function () {
        if (paused_at == null) {
          return;
        }
        // 停止していた時間分だけ開始時刻をずらして再開
        start_time += performance.now() - paused_at;
        paused_at = null;
        timer = requestAnimationFrame(update);
      };
      timer = requestAnimationFrame(update);
      elem.classList.add('has-timer');
    }

    function startSlideTimer(slide) {
      if (!slide) {
        return;
      }
      const v = slide.querySelector('video');
      if (v) {
        videoTimer(slide, v);
        if (isNavigationOpen()) {
          // ナビゲーションメニューが閉じられた時に resume_timer で再生する
          return;
        }
        const play_promise = v.play();
        if (play_promise) {
          play_promise.catch((e) => {
            // 自動再生が拒否された場合（iOS低電力モード等）は時間ベースのタイマーで代替
            // ※スライド切替時の pause() による AbortError は対象外
            if (e.name !== 'NotAllowedError' || !slide.classList.contains('has-timer')) {
              return;
            }
            slide.remove_timer();
            sliderTimer(slide, v.duration > 0 ? v.duration * 1000 : undefined);
          });
        }
      } else {
        // ビデオがない場合は時間ベースのタイマー
        sliderTimer(slide);
        if (isNavigationOpen()) {
          slide.pause_timer();
        }
      }
    }

    // ナビゲーションメニューを開いている間は表示中スライドのタイマー・動画を止める
    const NAVIGATION_OPEN_CLASS = 'is-search-menu-open';
    function isNavigationOpen() {
      return document.body.classList.contains(NAVIGATION_OPEN_CLASS);
    }

    function getActiveSubSlide() {
      const main_slide = slider_main.slides[slider_main.activeIndex];
      const sub_slider = main_slide && main_slide.querySelector('.index-sub-slider');
      if (!sub_slider || !sub_slider.swiper) {
        return null;
      }
      return sub_slider.swiper.slides[sub_slider.swiper.activeIndex];
    }

    document.addEventListener('navigation:open', () => {
      const slide = getActiveSubSlide();
      if (slide && typeof slide.pause_timer === 'function') {
        slide.pause_timer();
      }
    });
    document.addEventListener('navigation:close', () => {
      const slide = getActiveSubSlide();
      if (slide && typeof slide.resume_timer === 'function') {
        slide.resume_timer();
      }
    });

    // 動画の実際の再生位置を毎フレーム読んでプログレスバーに反映
    function videoTimer(elem, v) {
      let timer;
      let is_discarded = false;
      let previous_time = v.currentTime;
      let previous_frame = performance.now();
      const update = (time) => {
        if (is_discarded) {
          return;
        }
        const current_time = v.currentTime;
        // 裏タブ等で rAF が止まっていた直後は巻き戻り判定をせず基準を取り直す
        const is_resumed = time - previous_frame > 500;
        previous_frame = time;
        if (!is_resumed && current_time < previous_time) {
          // ループで先頭に戻った = 再生終了
          updateSliderProgressIndicator(elem, 1);
          subSliderSlideNext(elem);
          if (is_discarded) {
            return;
          }
        }
        previous_time = current_time;
        if (v.duration > 0) {
          updateSliderProgressIndicator(elem, Math.min(current_time / v.duration, 1));
        }
        timer = requestAnimationFrame(update);
      };
      elem.remove_timer = function () {
        is_discarded = true;
        cancelAnimationFrame(timer);
        updateSliderProgressIndicator(elem, 0);
        elem.remove_timer = null;
        elem.pause_timer = null;
        elem.resume_timer = null;
        elem.classList.remove('has-timer');
      };
      elem.pause_timer = function () {
        v.pause();
      };
      elem.resume_timer = function () {
        const play_promise = v.play();
        if (play_promise) {
          play_promise.catch(() => {});
        }
      };
      timer = requestAnimationFrame(update);
      elem.classList.add('has-timer');
    }

    function subSliderSlideNext(elem) {
      const sub_slider = elem.closest('.index-sub-slider');
      if (sub_slider && sub_slider.slider) {
        const next_index =
          sub_slider.slider.realIndex + 1 < sub_slider.slider.slides.length ? sub_slider.slider.realIndex + 1 : 0;
        sub_slider.swiper.slideTo(next_index, 600, false);
        if (next_index === 0) {
          // メインスライダーを次に進める
          mainSliderEdgeSlideNext();
        }
      }
    }

    // header_control_swiper.controller.control = [slider_main];
    slider_main.controller.control = [header_control_swiper];

    function unlockEdgeFunction() {
      slider_main.lock_edge_function = false;
    }
    unlockEdgeFunction();

    function mainSliderEdgeSlidePrev() {
      const prev_index = slider_main.realIndex - 1 >= 0 ? slider_main.realIndex - 1 : slider_main.slides.length - 1;
      const active_sub_slider = sub_sliders[prev_index];
      slider_main.lock_edge_function = true;
      // slidePrev() は現在の translate がスナップ位置からずれていると(横スライド中など)
      // 前のスライドを特定できず先頭へ戻ってしまうため、インデックスを指定して移動する
      slider_main.slideTo(prev_index, 400, true);

      if (active_sub_slider != null && typeof active_sub_slider.swiper != 'undefined') {
        active_sub_slider.swiper.slideTo(active_sub_slider.swiper.slides.length - 1, 600, false);
      }
    }

    function mainSliderEdgeSlideNext() {
      const next_index = slider_main.realIndex + 1 <= slider_main.slides.length - 1 ? slider_main.realIndex + 1 : 0;
      const active_sub_slider = sub_sliders[next_index];
      slider_main.lock_edge_function = true;
      slider_main.slideTo(next_index, 400, true);

      if (active_sub_slider != null && typeof active_sub_slider.swiper != 'undefined') {
        active_sub_slider.swiper.slideTo(0, 600, false);
      }
    }

    // PCのホイール操作で、サブスライダーの終端からさらにスクロールした量を
    // メインスライダーの横移動に変換し、閾値を超えたら隣のカテゴリへ移動する
    const EDGE_WHEEL_GESTURE_GAP = 250; // これ以上ホイールイベントが途切れたら別ジェスチャーとみなす(ms)
    const EDGE_WHEEL_THRESHOLD = 150; // カテゴリ移動に必要なスクロール量(px)
    const EDGE_WHEEL_HISTORY_SIZE = 8; // 加速・減衰の判定に使う直近のホイール量の数
    const EDGE_WHEEL_MIN_ACCEL_DELTA = 8; // 再加速とみなす最小のホイール量(px)
    const edge_wheel = {
      last_time: 0,
      direction: 0, // 1: 次のカテゴリへ / -1: 前のカテゴリへ / 0: 無効
      amount: 0,
      base_translate: 0,
      release_timer: null,
      paused_slide: null, // 横スライド中に一時停止しているスライド
      is_suppressed: false, // カテゴリ移動後、同じジェスチャーの残り(慣性含む)を無視する
      history: [], // 直近のホイール量(絶対値)
      is_decaying: false, // ホイール量が減衰中(=慣性スクロール中)か
    };

    function pauseEdgeWheelSlide(swiper) {
      const slide = swiper.slides[swiper.activeIndex];
      if (slide && typeof slide.pause_timer === 'function') {
        slide.pause_timer();
        edge_wheel.paused_slide = slide;
      }
    }

    function resumeEdgeWheelSlide() {
      const slide = edge_wheel.paused_slide;
      edge_wheel.paused_slide = null;
      if (slide && typeof slide.resume_timer === 'function' && !isNavigationOpen()) {
        slide.resume_timer();
      }
    }

    // カテゴリ移動時はメインスライダー側でタイマーが再設定されるため再開しない
    function discardEdgeWheelSlide() {
      edge_wheel.paused_slide = null;
    }

    function normalizeWheelDelta(evt) {
      if (evt.deltaMode === 1) {
        return evt.deltaY * 16;
      }
      if (evt.deltaMode === 2) {
        return evt.deltaY * window.innerHeight;
      }
      return evt.deltaY;
    }

    function resetEdgeWheel(animate) {
      if (edge_wheel.direction !== 0 && edge_wheel.amount > 0 && animate) {
        slider_main.slideReset(300);
      }
      resumeEdgeWheelSlide();
      edge_wheel.direction = 0;
      edge_wheel.amount = 0;
    }

    function applyEdgeWheelTranslate() {
      const max_offset = slider_main.width * 0.5;
      const offset = Math.min(edge_wheel.amount, max_offset) * edge_wheel.direction * -1;
      slider_main.setTransition(0);
      slider_main.setTranslate(edge_wheel.base_translate + offset);
    }

    function average(values) {
      return values.reduce((sum, v) => sum + v, 0) / values.length;
    }

    // 新しいスクロール操作の開始を判定する
    // ・ホイールイベントが一定時間途切れた
    // ・慣性で減衰していたホイール量が再び増加した(慣性中に指で再度スクロールした)
    function detectNewGesture(now, magnitude) {
      const is_gap = now - edge_wheel.last_time > EDGE_WHEEL_GESTURE_GAP;
      edge_wheel.last_time = now;
      if (is_gap) {
        edge_wheel.history = [magnitude];
        edge_wheel.is_decaying = false;
        return true;
      }

      const history = edge_wheel.history;
      history.push(magnitude);
      if (history.length > EDGE_WHEEL_HISTORY_SIZE) {
        history.shift();
      }
      if (history.length < EDGE_WHEEL_HISTORY_SIZE) {
        return false;
      }
      const half = EDGE_WHEEL_HISTORY_SIZE / 2;
      const older = average(history.slice(0, half));
      const newer = average(history.slice(half));
      if (newer < older * 0.9) {
        edge_wheel.is_decaying = true;
      } else if (edge_wheel.is_decaying && newer > older * 1.5 && newer >= EDGE_WHEEL_MIN_ACCEL_DELTA) {
        edge_wheel.history = history.slice(half);
        edge_wheel.is_decaying = false;
        return true;
      }
      return false;
    }

    function handleEdgeWheel(sub_slider, evt) {
      const now = performance.now();
      const magnitude = Math.max(Math.abs(evt.deltaX), Math.abs(normalizeWheelDelta(evt)));
      const is_new_gesture = detectNewGesture(now, magnitude);

      clearTimeout(edge_wheel.release_timer);
      edge_wheel.release_timer = setTimeout(() => resetEdgeWheel(true), EDGE_WHEEL_GESTURE_GAP);

      if (is_new_gesture && !slider_main.lock_edge_function && !slider_main.animating) {
        edge_wheel.is_suppressed = false;
      }
      if (edge_wheel.is_suppressed) {
        // 移動先カテゴリのSwiperに慣性スクロールが渡って連続でスライドしないよう、
        // ジェスチャーが途切れるまで全てのホイールイベントを止める
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }

      if (Math.abs(evt.deltaY) <= Math.abs(evt.deltaX)) {
        return;
      }

      const swiper = sub_slider.swiper;
      const delta = normalizeWheelDelta(evt);
      if (!swiper || delta === 0) {
        return;
      }

      const direction = delta > 0 ? 1 : -1;
      if (is_new_gesture && edge_wheel.direction !== direction) {
        // 慣性スクロールで終端に到達した場合を除外するため、
        // ジェスチャー開始時点で既に終端にいる場合のみ受け付ける
        // (同じ方向に横スライド中なら、そのまま移動量を引き継ぐ)
        resetEdgeWheel(true);
        const is_at_edge = direction > 0 ? swiper.isEnd : swiper.isBeginning;
        if (!is_at_edge || slider_main.lock_edge_function || slider_main.animating || swiper.animating) {
          return;
        }
        edge_wheel.direction = direction;
        edge_wheel.base_translate = slider_main.translate;
        // 横スライド中は表示中スライドのタイマー・動画を止める
        pauseEdgeWheelSlide(swiper);
      }

      if (edge_wheel.direction === 0) {
        return;
      }
      if (slider_main.lock_edge_function || slider_main.animating) {
        // タイマー等で別途カテゴリ移動が始まった場合は中断
        discardEdgeWheelSlide();
        edge_wheel.direction = 0;
        edge_wheel.amount = 0;
        return;
      }

      // 終端での操作中はSwiper側のホイール処理に渡さない
      evt.preventDefault();
      evt.stopImmediatePropagation();
      edge_wheel.amount = Math.max(edge_wheel.amount + delta * edge_wheel.direction, 0);

      if (edge_wheel.amount >= EDGE_WHEEL_THRESHOLD) {
        // 移動後は同じジェスチャー(慣性含む)が終わるまで無効化
        const move_direction = edge_wheel.direction;
        discardEdgeWheelSlide();
        edge_wheel.is_suppressed = true;
        edge_wheel.direction = 0;
        edge_wheel.amount = 0;
        if (move_direction > 0) {
          mainSliderEdgeSlideNext();
        } else {
          mainSliderEdgeSlidePrev();
        }
        return;
      }
      applyEdgeWheelTranslate();
    }

    sub_sliders.forEach((sub_slider) => {
      const pagination = sub_slider.querySelector('.index-sub-slider__pagination');
      function adjustPaginationPosition(swiper) {
        const pagination_rect = pagination.getBoundingClientRect();
        const scroll_height = pagination.scrollHeight;
        const position_adjust = swiper.activeIndex - swiper.previousIndex > 0 ? 3.5 : 0;
        const bullets = swiper.pagination.bullets;
        const active_bullet = bullets[Math.min(swiper.activeIndex, bullets.length - 1)];
        const active_bullet_rect = active_bullet.getBoundingClientRect();

        // console.log(
        //   position_adjust,
        //   pagination_rect.height,
        //   active_bullet_rect.top,
        //   pagination.scrollTop,
        //   scroll_height
        // );

        if (pagination_rect.height < scroll_height) {
          const pagination_st = pagination.scrollTop;
          const pagination_area_center = pagination_rect.height / 2 - pagination_rect.width * 3 * 0.5;
          const centered_scroll_position = Math.max(
            Math.min(
              pagination_st +
                active_bullet_rect.top -
                pagination_rect.top -
                pagination_area_center -
                position_adjust * pagination_rect.width,
              scroll_height
            ),
            0
          );
          // console.log(centered_scroll_position);
          pagination.classList.add('is-overflowed');
          pagination.scrollTo({ top: centered_scroll_position, behavior: 'smooth' });
        } else {
          pagination.classList.remove('is-overflowed');
          pagination.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
      sub_slider.slider = new Swiper(sub_slider, {
        direction: 'vertical',
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        parallax: true,
        speed: 600,
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
          el: pagination,
        },
        on: {
          touchStart: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (evt.type == 'pointerdown') {
                swiper._touch_start_y = evt.clientY;
              } else {
                swiper._touch_start_y = evt.touches[0].clientY;
              }
            }
          },
          touchMove: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (evt.type == 'pointermove') {
                swiper._touch_move_y = evt.clientY;
              } else {
                swiper._touch_move_y = evt.touches[0].clientY;
              }
            }
          },
          touchEnd: (swiper, evt) => {
            if (swiper.slides.length == 1) {
              if (swiper._touch_start_y != null && swiper._touch_move_y != null) {
                const delta_y = swiper._touch_move_y - swiper._touch_start_y;
                swiper._touch_start_y = null;
                swiper._touch_move_y = null;
                if (slider_main.lock_edge_function == false) {
                  if (delta_y < swiper.params.edgeSwipeThreshold * -1) {
                    console.log('DOWN');
                    mainSliderEdgeSlideNext();
                  } else if (delta_y > swiper.params.edgeSwipeThreshold * 1) {
                    console.log('UP');
                    mainSliderEdgeSlidePrev();
                  }
                }
              }
            }
          },
          progress: (swiper, progress) => {
            if (slider_main.lock_edge_function == false) {
              if (progress < 0) {
                mainSliderEdgeSlidePrev();
              } else if (progress > 1) {
                mainSliderEdgeSlideNext();
              }
            }
          },
          transitionStart: (swiper) => {
            // スライダーのタイマーをリセット
            resetAllSubSlideTimers();

            startSlideTimer(swiper.slides[swiper.activeIndex]);

            // ページネーションの位置を調整
            adjustPaginationPosition(swiper);
          },
          transitionEnd: (swiper) => {
            const slides = swiper.slides;
            const prev_slide = slides[swiper.previousIndex];
            if (prev_slide.querySelector('video')) {
              const v = prev_slide.querySelector('video');
              v.pause();
              v.currentTime = 0;
            }
          },
        },
      });
      // Swiperのホイール処理より先に判定するためキャプチャフェーズで登録
      sub_slider.addEventListener('wheel', (evt) => handleEdgeWheel(sub_slider, evt), {
        capture: true,
        passive: false,
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initIndexSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initRelatedSlider);
  function initRelatedSlider() {
    const containers = document.querySelectorAll('product-recommendations');
    const config = { attributes: false, childList: true, subtree: false };

    containers.forEach((container) => {
      function init(mutationList, observer) {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            requestAnimationFrame(() => {
              const slider = container.querySelector('.swiper');
              const swiper = new Swiper(slider, {
                freeMode: true,
                slidesPerView: 'auto',
                mousewheel: true,
              });
            });
          }
        }
      }

      const observer = new MutationObserver(init);
      observer.observe(container, config);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
